export const AFFILIATE_POSTBACKS_SETTINGS_ROUTE_NAME = Symbol('affiliate.postbacks.settings');
export const ADMIN_POSTBACKS_SETTINGS_ROUTE_NAME = Symbol('affiliate.postbacks.settings');

export const ADMIN_POSTBACKS_GET_URL = 'admin/affiliates/:id/webhooks/:postbackId/edit';
export const AFFILIATE_POSTBACKS_GET_URL = 'affiliate/webhooks/:postbackId/edit';

export const ADMIN_POSTBACKS_SAVE_URL = 'admin/affiliates/:id/webhooks/:postbackId';
export const AFFILIATE_POSTBACKS_SAVE_URL = 'affiliate/webhooks/:postbackId';
export const POSTBACKS_SAVE_MUTATION_KEY = 'postbacks.save';

export const ADMIN_POSTBACKS_TRACKERS_SAVE_URL = 'admin/affiliates/:id/webhooks/:postbackId/serials/:addType';
export const AFFILIATE_POSTBACKS_TRACKERS_SAVE_URL = 'affiliate/webhooks/:postbackId/serials/:addType';
export const POSTBACKS_SAVE_TRACKERS_MUTATION_KEY = 'postbacks.trackers.save';

export const ADMIN_POSTBACKS_CONDITION_SAVE_URL = 'admin/affiliates/:id/webhooks/:postbackId/conditions/:conditionId';
export const AFFILIATE_POSTBACKS_CONDITION_SAVE_URL = 'affiliate/webhooks/:postbackId/conditions/:conditionId';
export const POSTBACKS_SAVE_CONDITION_MUTATION_KEY = 'postbacks.condition.save';

export const ADMIN_POSTBACKS_URL_OPTIONS_SAVE_URL = 'admin/affiliates/:id/webhooks/:postbackId/uri_options/:optionId';
export const AFFILIATE_POSTBACKS_URL_OPTIONS_SAVE_URL = 'affiliate/webhooks/:postbackId/uri_options/:optionId';
export const POSTBACKS_SAVE_URL_OPTION_MUTATION_KEY = 'postbacks.url-option.save';

export const POSTBACKS_GET_QUERY_KEY = 'postbacks.get';
